import React, { useCallback } from 'react';
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  MenuDivider,
  MenuPopover,
  MenuTrigger,
} from '@fluentui/react-components';
import {
  Add20Regular,
  ArrowUpload20Regular,
  ImageMultiple20Regular,
  FolderAdd20Regular,
} from '@fluentui/react-icons';
import { SparkeSVGIcon } from '../../asset-images';

const AddFromAnotherSourceSubMenu = (props) => {
  const {
    i18n,
    onUploadImage,
    onUploadVideo,
  } = props;

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <MenuItem className="add-asset-button" icon={<ImageMultiple20Regular />}>
          {i18n.getString(_TL_('Add from another source'))}
        </MenuItem>
      </MenuTrigger>

      <MenuPopover>
        <MenuList className="add-asset-menu-list">
          <MenuItem className="add-image-button" onClick={onUploadImage}>
            {i18n.getString(_TL_('Add image'))}
          </MenuItem>
          <MenuItem className="add-video-button" onClick={onUploadVideo}>
            {i18n.getString(_TL_('Add video'))}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

const UploadFromComputerSubMenu = (props) => {
  const {
    i18n,
    onUploadLocalFile,
    onUploadLocalFolder,
  } = props;

  return (
    <Menu>
      <MenuTrigger disableButtonEnhancement>
        <MenuItem className="upload-button" icon={<ArrowUpload20Regular />}>
          {i18n.getString(_TL_('Upload from computer'))}
        </MenuItem>
      </MenuTrigger>

      <MenuPopover>
        <MenuList className="upload-menu-list">
          <MenuItem className="upload-file-button" onClick={onUploadLocalFile}>
            {i18n.getString(_TL_('Upload file'))}
          </MenuItem>
          <MenuItem className="upload-folder-button" onClick={onUploadLocalFolder}>
            {i18n.getString(_TL_('Upload folder'))}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

export const NewDropDown = (props) => {
  const {
    i18n,
    className,
    logger,
    onUploadLocalFileClick,
    onUploadLocalFolderClick,
    onUploadImageClick,
    onUploadVideoClick,
    onAIGenerateClick,
    onCreateFolderClick,
    handleUsage,
  } = props;

  const onUploadLocalFile = useCallback(() => {
    logger.logTrace('Add assets - file upload is clicked');
    onUploadLocalFileClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onUploadLocalFileClick]);

  const onUploadLocalFolder = useCallback(() => {
    logger.logTrace('Add assets - folder upload is clicked');
    onUploadLocalFolderClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onUploadLocalFolderClick]);

  const onUploadImage = useCallback(() => {
    logger.logTrace('Add assets - image source is clicked');
    onUploadImageClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onUploadImageClick]);

  const onUploadVideo = useCallback(() => {
    logger.logTrace('Add assets - video source is clicked');
    onUploadVideoClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onUploadVideoClick]);

  const onAIGenerate = useCallback(() => {
    logger.logTrace('Add assets - ai generate image clicked');
    onAIGenerateClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onAIGenerateClick]);

  const onCreateFolder = useCallback(() => {
    logger.logTrace('Create folder is clicked');
    onCreateFolderClick();
    if (handleUsage) {
      handleUsage();
    }
  }, [handleUsage, logger, onCreateFolderClick]);

  return (
    <div className={className}>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <MenuButton className="new-drop-button" appearance="primary" icon={<Add20Regular />}>
            {i18n.getString(_TL_('New'))}
          </MenuButton>
        </MenuTrigger>

        <MenuPopover>
          <MenuList className="new-menu-list">
            <MenuItem className="generate-images-button" icon={<SparkeSVGIcon />} onClick={onAIGenerate}>
              {i18n.getString(_TL_('Generate images'))}
            </MenuItem>
            <MenuDivider />
            <UploadFromComputerSubMenu
              i18n={i18n}
              onUploadLocalFile={onUploadLocalFile}
              onUploadLocalFolder={onUploadLocalFolder}
            />
            <AddFromAnotherSourceSubMenu
              i18n={i18n}
              onUploadImage={onUploadImage}
              onUploadVideo={onUploadVideo}
            />
            <MenuItem className="create-folder-button" icon={<FolderAdd20Regular />} onClick={onCreateFolder}>
              {i18n.getString(_TL_('Create folder'))}
            </MenuItem>
          </MenuList>
        </MenuPopover>
      </Menu>
    </div>
  );
};
